import { usePathname } from 'next/navigation'

import Avatar from '@components/avatar'
import Button from '@components/buttons/button'
import useIsLoggedIn from '@hooks/user/useIsLoggedIn'

import styles from './menu-links.module.scss'
import useLocale from '@hooks/client/useLocale'

export default function MenuLinks({ close }: { close: () => void }): JSX.Element {
  const pathname = usePathname()
  const locale = useLocale()
  const { isUserLoggedIn } = useIsLoggedIn()

  const links = [
    { href: `/${locale}`, title: 'Home' },
    // { href: `/${locale}/ai-agent`, title: 'AI Agent' },
    { href: `/${locale}/blogs`, title: 'Our community' },
    { href: `/${locale}/jobs`, title: 'Browse jobs' },
  ]

  return (
    <ul className={styles.links}>
      {links.map((el, i) => (
        <li key={i}>
          <Button variant="simple-text" href={pathname === el.href ? undefined : el.href} onClick={close}>
            {el.title}
          </Button>
        </li>
      ))}
      {locale !== 'us' && (
        <li>
          <Button
            variant="simple-text"
            href={isUserLoggedIn ? `/${locale}/profile` : `/${locale}/login`}
            onClick={close}
          >
            {isUserLoggedIn ? (
              <>
                <Avatar /> <p>My account</p>
              </>
            ) : (
              'Login'
            )}
          </Button>
        </li>
      )}
    </ul>
  )
}
